import React, { useMemo, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import FAQSearchInput from "../../components/FAQ/FAQSearchInput/FAQSearchInput";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
// import VideoPanel from "../../components/FAQ/VideoPanel/VideoPanel";
import { fetchFAQ } from "../../services/InstructionService";
import "./FAQ.css";

// const videos = [
//   {
//     title: "eSIM QRCode sharing",
//     url: "https://www.youtube.com/shorts/X3wx1KVTzJ0",
//   },
//   {
//     title: "Sharing Funds, WalletID",
//     url: "https://www.youtube.com/shorts/S1Obzd1QTzw",
//   },

//   {
//     title: "eSIM Balance, Auto Renewal, eSIM Top Up",
//     url: "https://www.youtube.com/shorts/0tW7J9rQngo",
//   },
//   {
//     title: "eSIM installation",
//     url: "https://www.youtube.com/shorts/l2-aDj4Rw1I",
//   },
//   {
//     title: "Transaction History",
//     url: "https://www.youtube.com/shorts/Q18y9VgicZY",
//   },
//   {
//     title: "Registration and Login",
//     url: "https://www.youtube.com/shorts/Q1JiSedDQxo",
//   },
//   { title: "eSIM Purchase", url: "https://www.youtube.com/shorts/OyJxKYkLaBI" },
// ];

import { useTranslation } from "react-i18next";
import "./FAQ.css";

export default function FAQ() {
  const { t, i18n } = useTranslation();
  const [query, setQuery] = useState("");
  const [openIndex, setOpenIndex] = useState(null);

  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const data = await fetchFAQ({ language: i18n.language || "en" });
        const flatList = data.flatMap((section) =>
          section.data.map((item) => ({
            id: item.id,
            q: item.question,
            a: item.answer,
          })),
        );

        setFaqs(flatList);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [i18n.language]);

  const normalized = query.trim().toLowerCase();

  const filtered = useMemo(() => {
    if (!faqs.length) return [];

    const indexedFaqs = faqs.map((f, i) => ({ ...f, _i: i }));

    if (!normalized) return indexedFaqs;

    return indexedFaqs.filter((f) => f.q.toLowerCase().includes(normalized) || f.a.toLowerCase().includes(normalized));
  }, [normalized, faqs]);

  const toggle = (idx) => setOpenIndex((curr) => (curr === idx ? null : idx));

  const highlight = (text) => {
    if (!text) return "";
    if (!normalized) return text;

    const re = new RegExp(`(${escapeRegExp(normalized)})`, "ig");
    return text.split(re).map((part, i) =>
      part.toLowerCase() === normalized ? (
        <mark key={i} className="hl">
          {part}
        </mark>
      ) : (
        <React.Fragment key={i}>{part}</React.Fragment>
      ),
    );
  };

  return (
    <div className="faq-container">
      <PageHeader
        title={t("faq.title")}
        description={t("faq.subtitle")}
        searchInput={
          <FAQSearchInput
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("faq.search")}
          />
        }
      />

      <div id="faq-list" className="faq-accordion" aria-label="FAQ list">
        {loading && <div style={{ textAlign: "center", padding: "2rem" }}>{t("common.loading")}</div>}

        {!loading && filtered.length === 0 && (
          <div style={{ textAlign: "center", padding: "2rem" }}>{t("faq.noResults")}</div>
        )}

        {!loading &&
          filtered.map((item) => {
            const i = item._i;
            const isOpen = openIndex === i;
            const btnId = `faq-header-${i}`;
            const panelId = `faq-panel-${i}`;

            return (
              <div className="faq-item" key={item.id || i}>
                <h3 className="faq-heading">
                  <button
                    id={btnId}
                    className={`faq-button ${isOpen ? "open" : ""}`}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={() => toggle(i)}
                  >
                    <span className="faq-question">{highlight(item.q)}</span>
                    <span className="faq-icon" aria-hidden="true">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>
                </h3>

                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={btnId}
                  className={`faq-panel ${isOpen ? "show" : "hide"}`}
                >
                  {String(item.a)
                    .split("\n")
                    .map((line, j) => (
                      <p key={j} className="faq-answer">
                        {highlight(line)}
                      </p>
                    ))}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
